import { useCallback } from "react";
import useGraphQlDataClient from "../../../internal/revamp/config/useGraphQlDataClient";
/**
 *
 * @see https://sail.stripe.me/data/api/unstable_useInvalidateTopLevelFields
 */ export default function useInvalidateTopLevelFields() {
    const { observableStore } = useGraphQlDataClient();
    return useCallback((topLevelFields)=>{
        observableStore.invalidateTopLevelFields(topLevelFields);
    }, [
        observableStore
    ]);
}

//# sourceMappingURL=useInvalidateTopLevelFields.js.map